import my_account from './icons/ci_change/my_account_admin.svg';
import my_account_colored from './icons/ci_change/my_account_admin_colored.svg';
import license from './icons/ci_change/pa_ic_license.svg';
import license_off from './icons/ci_change/pa_ic_license_off.svg';
import license_card from './icons/ci_change/pa_ic_license_card.svg';
import check from './icons/pa_ic_check.png';
import select_type from './icons/pa_ic_select_type.png';
import enter_code from './icons/pa_ic_enter_code.png';
import datepicker_range from './icons/pa_ic_datepicker_range.svg';
import email from './icons/ci_change/pa_ic_email.svg';
import delete_inactive from './icons/pa_ic_delete_colored.png';
import delete_active from './icons/pa_ic_delete.png';
import success from './icons/ci_change/pa_ic_success.svg';
import warning from './icons/pa_ic_warning.png';
import warning_full from './icons/pa_ic_warning_full@2.png';
import error from './icons/ci_change/pa_ic_error.svg';
import log from './icons/ci_change/pa_ic_log.svg';
import log_off from './icons/ci_change/pa_ic_log_off.svg';
import permissions from './icons/ci_change/pa_ic_permissions.svg';
import permissions_off from './icons/ci_change/pa_ic_permissions_off.svg';
import support from './icons/ci_change/pa_ic_support.svg';
import support_off from './icons/ci_change/pa_ic_support_off.svg';
import sw from './icons/ci_change/pa_ic_sw.svg';
import sw_off from './icons/ci_change/pa_ic_sw_off.svg';
import import_plus from './icons/ci_change/pa_ic_import.svg';
import pdf from './icons/pa_ic_pdf.png';
import phone from './icons/pa_ic_phone.svg';
import nodata from './icons/pa_ic_nodata.svg';
import progress from './icons/pa_ic_progress.svg';
import warning_circle from './icons/pa_warning_circle.png';
import warning_triangle from './icons/pa_ic_warning_error.svg';

import preprocessing_on from './icons/ci_change/pa_ic_preprocessing_on.svg';
import preprocessing_off from './icons/ci_change/pa_ic_preprocessing_off.svg';
import deleteX from './icons/pa_delete@2.png';
import modify_pencil from './icons/pa_modify_pencil@2.png';
import addInfo_plus from './icons/ci_change/pa_addInfo_plus.svg';
import close from './icons/pa_ic_close_24@2.png';
import search from './icons/ci_change/pa_ic_search.svg';
import searchBlack from './icons/ci_change/pa_ic_searchBlack.svg';

import iconWho from './icons/pa_icon_who.png';
import iconLocation from './icons/pa_icon_location.png';
import iconTel from './icons/pa_icon_tel.png';
import iconFax from './icons/pa_icon_fax.png';
import iconBusiness from './icons/pa_icon_business.png';
import iconReset from './icons/pa_ic_rotate_arrow.svg';
import transfer from './icons/ci_change/pa_ic_transfer.svg';
import arrowRightDisabled from './icons/pa_arrow_right_disabled.svg';
import arrowLeftDisabled from './icons/pa_arrow_left_disabled.svg';
import arrowRight from './icons/pa_arrow_right.svg';
import arrowLeft from './icons/pa_arrow_left.svg';
import refreshCircle from './icons/refresh_circle.svg';
import deleteIcon from './icons/delete.svg';
import emptyDeleteIcon from './icons/ci_change/close-circle.svg';
import emptyDeleteIconHover from './icons/ci_change/close-circle_hover.svg';
import emptyDeleteIconActive from './icons/ci_change/close-circle_active.svg';

import refresh from './icons/refresh_error_16.svg';

export const icons = {
  my_account,
  my_account_colored,
  license,
  license_off,
  license_card,
  log,
  log_off,
  permissions,
  permissions_off,
  support,
  support_off,
  sw,
  sw_off,
  check,
  select_type,
  enter_code,
  datepicker_range,
  email,
  delete_inactive,
  delete_active,
  success,
  warning,
  warning_circle,
  warning_full,
  error,
  import_plus,
  pdf,
  phone,
  nodata,
  progress,
  warning_triangle,
  preprocessing_on,
  preprocessing_off,
  deleteX,
  modify_pencil,
  addInfo_plus,
  close,
  search,
  searchBlack,

  iconWho,
  iconLocation,
  iconTel,
  iconFax,
  iconBusiness,
  iconReset,

  transfer,

  arrowRightDisabled,
  arrowLeftDisabled,
  arrowRight,
  arrowLeft,
  refreshCircle,
  deleteIcon,
  emptyDeleteIcon,
  emptyDeleteIconHover,
  emptyDeleteIconActive,
  refresh,
};
